/**
 * MFA policy and intent from Clerk `user.publicMetadata` (synced by backend on PATCH).
 * Falls back to legacy keys where noted for existing orgs.
 */

export function readPublicMetadataBoolean(metadata, ...keys) {
  if (metadata == null || typeof metadata !== "object") return undefined;
  for (const key of keys) {
    const v = metadata[key];
    if (v === true || v === "true" || v === 1) return true;
    if (v === false || v === "false" || v === 0) return false;
  }
  return undefined;
}

/** Organization requires MFA for members (Clerk metadata). */
export function isOrgMfaEnabled(user) {
  const m = user?.publicMetadata;
  return (
    readPublicMetadataBoolean(m, "org_mfa_enabled") === true ||
    readPublicMetadataBoolean(m, "org_mfa_required") === true
  );
}

/** Backend mirror: user opted in / MFA on in profile (may be true before TOTP enrollment). */
export function isPublicMetadataTwoFactorEnabled(user) {
  return (
    readPublicMetadataBoolean(
      user?.publicMetadata,
      "two_factor_enabled"
    ) === true
  );
}

/** User has completed TOTP enrollment in Clerk. */
export function isClerkTotpEnrolled(user) {
  return user?.twoFactorEnabled === true;
}
